import { getErrorMessage } from '@/shared/lib'
import { useAppStore } from '@/shared/store'
import { DelayedPromise } from './apiClient'
import { getApiService } from '@/api/getApiService'

let refreshTokenPromise: Promise<string | false> | null = null

export const handle401Error = async () => {
    const loginApi = getApiService()

    if (!refreshTokenPromise) {
        refreshTokenPromise = (async () => {
            try {
                const newAccessToken = await loginApi.refreshAccessToken()
                if (newAccessToken) {
                    useAppStore.setState((state) => ({
                        ...state,
                        accessToken: newAccessToken,
                        isUserLoggedIn: true,
                    }))
                    return newAccessToken
                } else {
                    useAppStore.setState((state) => ({
                        ...state,
                        isUserLoggedIn: false,
                    }))
                    return false
                }
            } catch (error) {
                getErrorMessage('handle401Error', error)
                throw error
            } finally {
                refreshTokenPromise = null
            }
        })()
    }

    return refreshTokenPromise
}

export const handleHttpErrorRetry = async (
    url: string,
    requestData: {
        method: string
        body: string | null
        headers: { 'Content-type': string; Authorization?: string }
    },
    maxRetryCount: number
) => {
    let jsonData
    let response

    for (let retryCounter = 0; retryCounter < maxRetryCount; retryCounter++) {
        try {
            response = await fetch(url, requestData)

            if (response.ok) {
                jsonData = await response.json()
                return jsonData
            } else if (response.status === 401) {
                const newAccessToken = await handle401Error()
                if (newAccessToken) {
                    requestData.headers.Authorization = `Bearer ${newAccessToken}`
                    continue
                } else {
                    throw new Error('User is not logged in after token refresh')
                }
            } else {
                throw new Error(`HTTP error: ${response.status}`)
            }
        } catch (error: unknown) {
            if (retryCounter >= maxRetryCount - 1) {
                throw new Error('Failed to fetch data after multiple attempts')
            }

            await DelayedPromise(1000)
        }
    }

    throw new Error('Unexpected error in handleHttpErrorRetry function')
}
